export default "__VITE_ASSET__fa411997__"